import React from 'react';
import PropTypes from 'prop-types';

import Brand from 'models/brand';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const HowItWorksHeader = ({ brand }) => (
  <div className="background-image-smooth-p-gradient padding-top-xs-80 padding-top-md-120 padding-bottom-md-40">
    <div className="container text-center">
      <a href="/" className="hidden-xs hidden-sm header-logo-dark">
        <img src={brand.logoLightURL} alt={brand.displayName} />
      </a>
      <div className="row visible-xs visible-sm">
        <div className="col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 margin-top-negative-60">
          <a href="/">
            <picture>
              <img src={brand.logoLightURL} alt={brand.displayName} />
            </picture>
          </a>
        </div>
      </div>
      <h1 className="text-size-xs-28 text-size-md-72 text-weight-black text-color-dark-slate line-height-full margin-top-60 margin-bottom-10">
        HOW IT WORKS
      </h1>
      <p className="text-color-dark-slate text-size-xs-14 text-size-sm-24 font-family-georgia margin-bottom-40">Book the Best Spaces &amp; Save Up to 50%</p>
    </div>
  </div>
);

HowItWorksHeader.propTypes = propTypes;
export default HowItWorksHeader;
